import { Controller, useFormContext } from "react-hook-form";
import { companyOnboardingInputs } from "../helper";
import HelperText from "@components/form/helper-text";
import { phoneNumberFormat } from "../../../config/util/PhoneNumberFormatter";

export default function Step1() {
    const { control, trigger, formState: { errors }, clearErrors } = useFormContext()

    return (
        <>
            <div className="mt-1" />
            {companyOnboardingInputs?.[0]?.map(({ name, placeholder, type, triggerKey = "", helperText = "", ...input }, idx) => {
                return <div key={name}>
                    <Controller
                        name={name}
                        control={control}
                        render={({ field: { value, onChange }, fieldState }) => {
                            return (
                                <>
                                    <input.component
                                        value={value}
                                        onChange={(v) => {
                                            onChange(v)
                                            if (triggerKey) {
                                                trigger(triggerKey)
                                            }
                                        }}
                                        type={type}
                                        placeholder={placeholder}
                                        onBlur={(e) => {
                                            // runnning this only on number for a format .
                                            if (name == 'phoneNo') {
                                                const formattedNumber =
                                                    phoneNumberFormat(
                                                        e.target.value,
                                                    );
                                                if (
                                                    formattedNumber?.length ===
                                                    14
                                                ) {
                                                    clearErrors('phoneNo');
                                                    onChange(
                                                        formattedNumber,
                                                    );
                                                }
                                            } else {
                                                return
                                            }
                                        }}
                                    />
                                    {helperText && <HelperText>{helperText}</HelperText>}
                                    {fieldState?.error && <HelperText type="danger">{fieldState?.error.message}</HelperText>}
                                </>
                            )
                        }}
                    />
                </div>
            })}
        </>
    );
}
